<template>
  <v-btn
    v-if="isShown"
    size="x-large"
    icon="mdi-help-circle-outline"
    class="help-button"
    elevation="6"
    @click="onButtonClick"
  >
    <v-img heiht="60" width="60" src="@/assets/contact_icon.svg" />
  </v-btn>
</template>
<script lang="ts" setup>
import { computed } from 'vue'
import router from '@/router'
const emit = defineEmits(['click'])
const onButtonClick = () => emit('click')
const isShown = computed(
  () => router.currentRoute.value.name !== 'Session' && router.currentRoute.value.name !== 'Login'
)
</script>
<style scoped>
.help-button {
  position: fixed;
  bottom: 52px;
  right: 52px;

  line-height: 37.5px;
  font-size: 25px;
  font-weight: 400;
  font-family: 'Poppins', sans-serif;

  z-index: 3000;
}

@media (max-width: 375px) {
  .help-button {
    bottom: 5px;
    right: 12px;
  }
}
</style>
